export const isNewLicensee = referenceNumber => referenceNumber === "0000000"

export const getLicensee = referenceNumber => {
  const licensees = JSON.parse(localStorage.getItem("licensees"))
  return licensees.find(l => l.referenceNumber === referenceNumber)
}
